import styled from "styled-components";
const ListVariantStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@500&display=swap");
  .list-variant {
    background-color: white;
    border-top: 1px solid #e5e9f2;
    visibility: visible;
    direction: inherit;
    box-sizing: border-box !important;
    position: relative;
    display: block;
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    // min-height: 300px !important;
    max-height: 300px !important;
    // height: 300px !important;
    overflow: hidden scroll;
    margin-top: 5px;
    /* width */
    ::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgb(94, 84, 142);
      border-radius: 50px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .nv {
    color: rgb(94, 84, 142);
  }
  .dv {
    color: gray;
  }
  .nv,
  .dv {
    margin-bottom: 0.2rem;
    font-size: 10pt;
    font-family: "Roboto Slab", serif !important;
  }
  .imgVariant {
    min-width: 120px !important;
    width: 120px !important;
    max-width: 120px !important;
    border-radius: 10px !important;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    background: #ddddddb5;
  }

  .imgVariant:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
    border-color: transparent;
    background: #dddddd;
  }

  /* Estado seleccionado */
  .imgVariant.selected {
    border: 2px solid #014788 !important;
    box-shadow: 0 8px 25px #014788 !important;
    transform: scale(1.05);
    position: relative;
  }

  .imgVariant.selected::after {
    content: "✓";
    position: absolute;
    top: -8px;
    right: -8px;
    background: #014788;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 2px 8px #014788;
  }

  .imgVariant.selected:hover {
    transform: translateY(-5px) scale(1.08);
    box-shadow: 0 15px 35px #014788 !important;
  }
`;
export default ListVariantStyle;
